<template>
    <div>
        <ssv-order-voucher-form v-if="!voucher"/>
        <ssv-order-voucher-information v-if="voucher"/>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import SsvOrderVoucherForm from './VoucherForm';
    import SsvOrderVoucherInformation from './VoucherInformation';

    export default {
        name: 'SsvOrderVoucherContainer',
        components: {
            SsvOrderVoucherInformation,
            SsvOrderVoucherForm
        },
        computed: {
            ...mapGetters('ssvOrder', ['voucher'])
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/voucher/VoucherContainer.vue